// Valores por defecto de rulesTipsPrudence.
export const defaultRulesTipsPrudenceSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultAction = () => {
    return "";
};

// Valor por defecto de ruleTipPrudence.
export const defaultRuleTipPrudence = () => {
    return {
        id: null,
        name: null,
        sga_prudence_tip_code_combination_ids: [],
        sga_prudence_tip_code_display_ids: [],
    };
};

// Valores por defecto de filterRulesTipsPrudence.
export const defaultFilterRulesTipsPrudence = () => {
    return {
        name: null,
        is_active: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

export default {
    rulesTipsPrudence: defaultRulesTipsPrudenceSga(),
    action: defaultAction(),
    ruleTipPrudence: defaultRuleTipPrudence(),
    filterRulesTipsPrudence: defaultFilterRulesTipsPrudence(),
};
